module.exports = __webpack_public_path__ + "media/images/citb-13bd72477678cb031c3d01f67c596e52.svg";